import * as Sentry from '@sentry/react';
import api from 'api';
import { produce } from 'immer';

import getProjectId from 'utils/url/getProjectId';
import setProjectState from 'store/setProjectState';

import { IProjectState } from 'store';

function updateStateInStore(projectId: string, runId: string) {
  setProjectState(
    projectId,
    produce((state: IProjectState) => {
      if (!state.runsAsync.data) {
        return;
      }
      const run = state.runsAsync.data.items.find((run) => run.id === runId);
      if (run) {
        run.state = 'CANCELLED';
      }
    }),
  );
}

export default function cancelRun(runId: string) {
  const projectId = getProjectId();
  if (!projectId) return Promise.reject(new Error('No project ID'));

  return api
    .post(`projects/${projectId}/workflows/${runId}/operations`, {
      json: { type: 'CANCEL' },
    })
    .json()
    .then(
      () => {
        updateStateInStore(projectId, runId);
      },
      (error) => {
        Sentry.captureException(error);
        throw error;
      },
    );
}
